import VideoSlate from './VideoSlate';

export default VideoSlate;
